// Documents Skor asks for, per employment type. Copy of `forensic_docs_map`
// in uno-frontend `src/Utils/skorLiteDocumentMap.js` (the standard rules, not
// the `dea_missing_docs` ones). Keep in sync with the frontend by hand.
// Document names are the ones Skor lite returns.

const ID_DOCS = [
  "Passport",
  "National ID card (front)",
  "National ID card (back)",
  "Residence permit (front)",
  "Residence permit (back)",
];

// Employed and public servant tenants need one payslip for each of the last 3
// full months (the frontend matches uploads to those months). Shown as one
// entry; the modal adds the actual months.
export const LAST_3_PAYSLIPS = "Last 3 payslips";
const PAYSLIPS = [LAST_3_PAYSLIPS];

// The 3 months before the current one, most recent first (same as the
// frontend's getRequiredPayslipPeriods).
export const lastThreePayslipMonths = (today = new Date()) =>
  [1, 2, 3].map((i) =>
    new Date(today.getFullYear(), today.getMonth() - i, 1).toLocaleDateString(
      "en-GB",
      { month: "long", year: "numeric" },
    ),
  );

const type = (label, employment, income) => ({
  label,
  identification: ID_DOCS,
  employment_status: { additional: [], ...employment },
  income_taxes: { additional: [], ...income },
});

export const REQUIRED_DOCUMENTS = [
  type(
    "Student",
    {
      compulsory: ["University Acceptance Letter", "Student registration contract"],
    },
    { compulsory: [], additional: ["Payslip"] },
  ),
  type(
    "Employed",
    { compulsory: ["Employment contract", "Working life certificate"] },
    {
      compulsory: [
        ...PAYSLIPS,
        "Deduction certificate",
        "Last annual Tax Report (Model 100)",
      ],
    },
  ),
  type(
    "Domestic worker",
    { compulsory: ["Employment contract", "Working life certificate"] },
    {
      compulsory: [
        "Annual payment certificate",
        "Deduction certificate",
        "Last annual Tax Report (Model 100)",
      ],
      additional: ["Payslip"],
    },
  ),
  type(
    "Self-employed: freelancer",
    { compulsory: ["Working life certificate"] },
    {
      compulsory: [
        "Last annual Tax Report (Model 100)",
        "Last Fractionated Tax Report (Model 130)",
        "Deduction certificate",
        "Last quarterly VAT tax (Form 303)",
        "Self-employed Social Security Payment",
      ],
      additional: ["Payslip"],
    },
  ),
  type(
    "Self-employed: owns a company",
    {
      compulsory: ["Working life certificate", "Company Incorporation Documents"],
    },
    {
      compulsory: [
        "Last annual Tax Report (Model 100)",
        "Last Fractionated Tax Report (Model 130)",
        "Deduction certificate",
        "Last year's Corporate Tax Return",
        "Last year's Corporate balance sheet",
        "Last year's Corporate P&L",
      ],
      additional: ["Payslip"],
    },
  ),
  type(
    "Public servant",
    {
      compulsory: [
        "Working life certificate",
        "Official Appointment Notice (Official Gazette)",
      ],
    },
    {
      compulsory: [
        "Last annual Tax Report (Model 100)",
        ...PAYSLIPS,
        "Deduction certificate",
      ],
    },
  ),
  type(
    "Retired",
    { compulsory: [] },
    {
      compulsory: [
        "Comprehensive certificate of benefits",
        "Last revalorization letter",
        "Last annual Tax Report (Model 100)",
      ],
    },
  ),
  type(
    "Unemployed",
    { compulsory: ["Working life certificate"] },
    {
      compulsory: [
        "Comprehensive certificate of benefits",
        "Last annual Tax Report (Model 100)",
      ],
    },
  ),
  {
    // Company login tenants. Signatories' IDs come from KYB: shown when
    // present, never counted as missing.
    label: "Company (login tenant)",
    identification: [],
    company_identity: {
      compulsory: [
        "Company Tax ID Card (CIF)",
        "Company Incorporation Documents",
        "Commercial Registry Note (Nota Simple)",
        "Beneficial Ownership Deed",
      ],
      additional: [],
    },
    legal_representative: {
      compulsory: ["Power of Attorney (Signatory)"],
      additional: ID_DOCS,
    },
    company_income_taxes: {
      compulsory: [
        "Last year's Corporate balance sheet",
        "Last year's Corporate P&L",
        "Last year's Corporate Tax Return",
        "Annual VAT Summary (Form 390)",
        "Last quarterly VAT tax (Form 303)",
        "Tax Office / Social Security Clearance Certificate",
        "Commercial Solvency Report",
        "Company Bank Account Ownership Certificate",
      ],
      additional: [],
    },
  },
];

export const SECTION_TITLES = {
  identification: "Identification",
  employment_status: "Employment",
  income_taxes: "Income & taxes",
  company_identity: "Company identity",
  legal_representative: "Legal representative",
  company_income_taxes: "Income & taxes",
};
